import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

if (typeof window !== "undefined") {
  const suppressResizeObserverError = (event) => {
    if (event?.message?.includes("ResizeObserver loop")) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };
  window.addEventListener("error", suppressResizeObserverError);
  window.onerror = (message) => {
    if (String(message || "").includes("ResizeObserver loop")) {
      return true;
    }
    return false;
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
